var ur = window.location.href;
if(ur.includes('/product') && $('.simple-form-container').length == 0 && $('.reviewsss').length == 0){
 $(document).ready(function(){
//test 8 START
function checkAndExecute() {
    if ($('.faq-section section#shopify-section-sections--16760378196181__multicolumn_Ji7Dm7').length) {
        clearInterval(interval); // Stop checking once the elements are found
    } else if ($('section#shopify-section-sections--16760378196181__multicolumn_Ji7Dm7').length && $('.faq-section').length) {
        $('.faq-section').prepend($('section#shopify-section-sections--16760378196181__multicolumn_Ji7Dm7'));
    }
}
// Check every 500 milliseconds
var interval = setInterval(checkAndExecute, 500);
function checkAndAppend() {
  console.log('executing')
    if ($('.simple-badges-outer-container .multicolumn-card.content-container').length) {
        // The element is already present, so stop the interval
        clearInterval(interval);
    } else {
        // The element is not present, so append the content
        $('.simple-badges-outer-container').append('<div class="multicolumn-card content-container" bis_skin_checked="1"> <div class="multicolumn-card__image-wrapper multicolumn-card__image-wrapper--third-width multicolumn-card-spacing" bis_skin_checked="1"> <div class="media media--transparent media--adapt" style="padding-bottom: 18.999999999999996%;" bis_skin_checked="1"> <img src="//katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=3200" alt="Best &amp; Only Belts You Need" srcset="//katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=50 50w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=75 75w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=100 100w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=150 150w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=200 200w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=300 300w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=400 400w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=500 500w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=750 750w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=1000 1000w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=1250 1250w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=1500 1500w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=1750 1750w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=2000 2000w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=2250 2250w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=2500 2500w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=2750 2750w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=3000 3000w, //katamu.co/cdn/shop/files/kiMK6qo4T_a52ab744-988c-4e18-8a3f-70618e1190b2.png?v=1709630978&amp;width=3200 3200w" width="3200" height="608" loading="lazy" sizes=" (min-width: 1500px) calc((1500px - 115px) * 0.33 / 2), (min-width: 990px) calc((100vw - 115px) * 0.33 / 2), (min-width: 750px) calc((100vw - 100px) * 0.33 / 1), calc((100vw - 30px) * 0.33 / 1) " class="multicolumn-card__image"> </div></div><div class="multicolumn-card__info" bis_skin_checked="1"><h3 class="inline-richtext">Best &amp; Only Belts You Need</h3><div class="rte" bis_skin_checked="1"><p>"Was skeptical at first but decided to risk it as the designs looked too good, best decision I ever made, not only do they look amazing but quality is insane" - Aaron</p></div></div></div>');
    }
}
// Check every 500 milliseconds
var interval = setInterval(checkAndAppend, 500);
//test 8 END
var rev = 0; var timerrev = setInterval(function(){
  if($('body .custom-price-wrapper').length && $('.uspemojis-container').length == 0) {
$('body .custom-price-wrapper').after(' <div class="uspemojis-container"> <div class="uspemojis-item-container"><div class="uspemojis-icon-container"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <mask id="mask0_1_159" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#0D0D0D"></rect> </mask> <g mask="url(#mask0_1_159)"> <path d="M9.07495 16.25L12 14.475L14.925 16.25L14.15 12.925L16.75 10.675L13.325 10.4L12 7.24995L10.675 10.4L7.24995 10.675L9.84995 12.925L9.07495 16.25ZM12 23.3L8.64995 20H3.99995V15.35L0.699951 12L3.99995 8.64995V3.99995H8.64995L12 0.699951L15.35 3.99995H20V8.64995L23.3 12L20 15.35V20H15.35L12 23.3ZM12 20.5L14.5 18H18V14.5L20.5 12L18 9.49995V5.99995H14.5L12 3.49995L9.49995 5.99995H5.99995V9.49995L3.49995 12L5.99995 14.5V18H9.49995L12 20.5Z" fill="#575757"></path> </g> </svg> </div><div class="uspemoji-description"><strong>1000s OF 5-STAR REVIEWS:</strong> Join over 50,000 lifters who trust Katamu to protect their backs</div></div><div class="uspemojis-item-container"> <div class="uspemojis-icon-container"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <mask id="mask0_1_156" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#0D0D0D"></rect> </mask> <g mask="url(#mask0_1_156)"> <path d="M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20ZM5 8H19V6H5V8ZM12 14C11.7167 14 11.4792 13.9042 11.2875 13.7125C11.0958 13.5208 11 13.2833 11 13C11 12.7167 11.0958 12.4792 11.2875 12.2875C11.4792 12.0958 11.7167 12 12 12C12.2833 12 12.5208 12.0958 12.7125 12.2875C12.9042 12.4792 13 12.7167 13 13C13 13.2833 12.9042 13.5208 12.7125 13.7125C12.5208 13.9042 12.2833 14 12 14ZM8 14C7.71667 14 7.47917 13.9042 7.2875 13.7125C7.09583 13.5208 7 13.2833 7 13C7 12.7167 7.09583 12.4792 7.2875 12.2875C7.47917 12.0958 7.71667 12 8 12C8.28333 12 8.52083 12.0958 8.7125 12.2875C8.90417 12.4792 9 12.7167 9 13C9 13.2833 8.90417 13.5208 8.7125 13.7125C8.52083 13.9042 8.28333 14 8 14ZM16 14C15.7167 14 15.4792 13.9042 15.2875 13.7125C15.0958 13.5208 15 13.2833 15 13C15 12.7167 15.0958 12.4792 15.2875 12.2875C15.4792 12.0958 15.7167 12 16 12C16.2833 12 16.5208 12.0958 16.7125 12.2875C16.9042 12.4792 17 12.7167 17 13C17 13.2833 16.9042 13.5208 16.7125 13.7125C16.5208 13.9042 16.2833 14 16 14ZM12 18C11.7167 18 11.4792 17.9042 11.2875 17.7125C11.0958 17.5208 11 17.2833 11 17C11 16.7167 11.0958 16.4792 11.2875 16.2875C11.4792 16.0958 11.7167 16 12 16C12.2833 16 12.5208 16.0958 12.7125 16.2875C12.9042 16.4792 13 16.7167 13 17C13 17.2833 12.9042 17.5208 12.7125 17.7125C12.5208 17.9042 12.2833 18 12 18ZM8 18C7.71667 18 7.47917 17.9042 7.2875 17.7125C7.09583 17.5208 7 17.2833 7 17C7 16.7167 7.09583 16.4792 7.2875 16.2875C7.47917 16.0958 7.71667 16 8 16C8.28333 16 8.52083 16.0958 8.7125 16.2875C8.90417 16.4792 9 16.7167 9 17C9 17.2833 8.90417 17.5208 8.7125 17.7125C8.52083 17.9042 8.28333 18 8 18ZM16 18C15.7167 18 15.4792 17.9042 15.2875 17.7125C15.0958 17.5208 15 17.2833 15 17C15 16.7167 15.0958 16.4792 15.2875 16.2875C15.4792 16.0958 15.7167 16 16 16C16.2833 16 16.5208 16.0958 16.7125 16.2875C16.9042 16.4792 17 16.7167 17 17C17 17.2833 16.9042 17.5208 16.7125 17.7125C16.5208 17.9042 16.2833 18 16 18Z" fill="#575757"></path> </g></svg> </div><div class="uspemoji-description"><strong>30 DAY RISK-FREE TRIAL:</strong> If you don’t absolutely love your gear after 30 days, send it back. No questions asked.</div></div><div class="uspemojis-item-container"><div class="uspemojis-icon-container"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <mask id="mask0_1_153" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#0D0D0D"></rect> </mask> <g mask="url(#mask0_1_153)"> <path d="M12 22C9.68333 21.4167 7.77083 20.0875 6.2625 18.0125C4.75417 15.9375 4 13.6333 4 11.1V5L12 2L20 5V11.1C20 12.5167 19.7583 13.8792 19.275 15.1875C18.7917 16.4958 18.1 17.65 17.2 18.65L14 15.45C13.7 15.6333 13.3792 15.7708 13.0375 15.8625C12.6958 15.9542 12.35 16 12 16C10.9 16 9.95833 15.6083 9.175 14.825C8.39167 14.0417 8 13.1 8 12C8 10.9 8.39167 9.95833 9.175 9.175C9.95833 8.39167 10.9 8 12 8C13.1 8 14.0417 8.39167 14.825 9.175C15.6083 9.95833 16 10.9 16 12C16 12.3667 15.9542 12.7208 15.8625 13.0625C15.7708 13.4042 15.6333 13.7333 15.45 14.05L16.95 15.55C17.2833 14.8667 17.5417 14.15 17.725 13.4C17.9083 12.65 18 11.8833 18 11.1V6.375L12 4.125L6 6.375V11.1C6 13.1167 6.56667 14.95 7.7 16.6C8.83333 18.25 10.2667 19.35 12 19.9C12.4333 19.7667 12.8458 19.5958 13.2375 19.3875C13.6292 19.1792 14.0167 18.9333 14.4 18.65L15.8 20.05C15.25 20.5 14.6542 20.8917 14.0125 21.225C13.3708 21.5583 12.7 21.8167 12 22ZM12 14C12.55 14 13.0208 13.8042 13.4125 13.4125C13.8042 13.0208 14 12.55 14 12C14 11.45 13.8042 10.9792 13.4125 10.5875C13.0208 10.1958 12.55 10 12 10C11.45 10 10.9792 10.1958 10.5875 10.5875C10.1958 10.9792 10 11.45 10 12C10 12.55 10.1958 13.0208 10.5875 13.4125C10.9792 13.8042 11.45 14 12 14Z" fill="#575757"></path> </g></svg> </div><div class="uspemoji-description"><strong>USPA & USAPL LEGAL:</strong> Our gear is designed to perform at competition level & used by elite level athletes</div></div></div>')
clearInterval(timerrev);}if( rev > 200){clearInterval(timerrev);}rev++;}, 50);
   $('.free_shipping_msg').eq(0).append($('.free-shipping-label').eq(0))
   
    setTimeout(function(){ 
$('.free_shipping_msg').eq(0).append($('.free-shipping-label').eq(0))
}, 100);
       setTimeout(function(){ 
$('.free_shipping_msg').eq(0).append($('.free-shipping-label').eq(0))
}, 500); 
   
   $('.faqs-wrapper').eq(0).closest('.shopify-section').addClass('faq-section');
 // $('main .shopify-section').eq(0).after($('.faqs-wrapper').eq(0).closest('.shopify-section'));
var asdf = 0; var timerasdf = setInterval(function(){
  if($('span.h1.fera-productReviews-avgRating-val').length) {
 var imgClone = $('.custom-review img').eq(0).clone();
   var reviews = $('span.fera-productReviews-reviewCount').eq(0).html()
      var count = $('span.h1.fera-productReviews-avgRating-val').eq(0).attr('data-value');
    if(count == 0){
      $('.custom-review').addClass('hide');
    }
   $('.custom-review').eq(0).html('<div class="reviewsss"><b>' + count + ' </b><span>(' + reviews + ' Customer Reviews)</span></div>');
    
    
 
   $('.custom-review').prepend($('.fera-stars-rating.fera-productReviews-stars-rating').eq(0).clone())
clearInterval(timerasdf);}if( asdf > 200){clearInterval(timerasdf);}asdf++;}, 50);
  
      
      
   
   
   
   $('.usp_item').eq(0).prepend($(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <mask id="mask0_1_37" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9"></rect>
  </mask>
  <g mask="url(#mask0_1_37)">
    <path d="M11 19.425V12.575L5 9.1V15.95L11 19.425ZM13 19.425L19 15.95V9.1L13 12.575V19.425ZM11 21.725L4 17.7C3.68333 17.5167 3.4375 17.275 3.2625 16.975C3.0875 16.675 3 16.3417 3 15.975V8.025C3 7.65833 3.0875 7.325 3.2625 7.025C3.4375 6.725 3.68333 6.48333 4 6.3L11 2.275C11.3167 2.09167 11.65 2 12 2C12.35 2 12.6833 2.09167 13 2.275L20 6.3C20.3167 6.48333 20.5625 6.725 20.7375 7.025C20.9125 7.325 21 7.65833 21 8.025V15.975C21 16.3417 20.9125 16.675 20.7375 16.975C20.5625 17.275 20.3167 17.5167 20 17.7L13 21.725C12.6833 21.9083 12.35 22 12 22C11.65 22 11.3167 21.9083 11 21.725ZM16 8.525L17.925 7.425L12 4L10.05 5.125L16 8.525ZM12 10.85L13.95 9.725L8.025 6.3L6.075 7.425L12 10.85Z" fill="#0D0D0D"></path>
  </g>
</svg>`))
$('.usp_item').eq(1).prepend($(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <mask id="mask0_1_42" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9"></rect>
  </mask>
  <g mask="url(#mask0_1_42)">
    <path d="M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V12H19V10H5V20H12V22H5ZM19 24C17.7833 24 16.7208 23.6208 15.8125 22.8625C14.9042 22.1042 14.3333 21.15 14.1 20H15.65C15.8667 20.7333 16.2792 21.3333 16.8875 21.8C17.4958 22.2667 18.2 22.5 19 22.5C19.9667 22.5 20.7917 22.1583 21.475 21.475C22.1583 20.7917 22.5 19.9667 22.5 19C22.5 18.0333 22.1583 17.2083 21.475 16.525C20.7917 15.8417 19.9667 15.5 19 15.5C18.5167 15.5 18.0667 15.5875 17.65 15.7625C17.2333 15.9375 16.8667 16.1833 16.55 16.5H18V18H14V14H15.5V15.425C15.95 14.9917 16.475 14.6458 17.075 14.3875C17.675 14.1292 18.3167 14 19 14C20.3833 14 21.5625 14.4875 22.5375 15.4625C23.5125 16.4375 24 17.6167 24 19C24 20.3833 23.5125 21.5625 22.5375 22.5375C21.5625 23.5125 20.3833 24 19 24ZM5 8H19V6H5V8Z" fill="#0D0D0D"></path>
  </g>
</svg>`))
 initDTB()
}); 
}
function initDTB(){
Element.prototype.appendBefore = function(element) {
    element.parentNode.insertBefore(this, element);
};
  var globalctr = 1;
  var dCtr = 1;
jQuery(".product-form__input").each(function(i, e) { // select parent
  jQuery(this).addClass("d" + globalctr);
  jQuery(this).addClass('simple-form-container');
  if(jQuery(".d"+ globalctr + " select option").length > 0){
    jQuery("<div ></div>")
    	.attr('id', "r" + globalctr)   
     	.attr('class', "r" )
        .insertAfter(this);
  
  var select =jQuery(".d"+ globalctr + " select");
  var option1 = jQuery(".d"+ globalctr + " select option").eq(1).val();
      var selected = select.prop("selectedIndex");
  
	jQuery(".d"+globalctr+" select option").each(function(i, e) {
      
      
	  jQuery("<input type='radio'/><span></span>")
        .attr("value", jQuery(this).val())
        .attr("checked", i ==selected)
   		 .attr("data-id", globalctr)
    	  .html('<p>'+jQuery(this).html()+'</p>')
        .click(function () {
        
              const firstOptionValue = jQuery(this).val()
          const baseURI = jQuery(this)[0].baseURI;
          const productHandle = baseURI.split('/products/')[1].split('?')[0];       
          
           // setTimeout(function () {
           //      var options = jQuery(".d2 select option");
           //      var values = options.map(function () {
           //          return jQuery(this).text();
           //      }).get();
           //       // console.log("Option values:", values);

           //      // Update radio inputs in #r2
           //      values.forEach(function (value, index) {
           //          var radioLabel = jQuery("#r2 label").eq(index);
           //          var radioInput = radioLabel.find("input[type='radio']");
           //          var radioSpan = radioLabel.find("span p");

           //          radioSpan.text(value);

           //          if (value.includes("Unavailable")) {
           //              radioInput.prop("disabled", true);
           //              radioLabel.addClass("out-ct-st"); 

           //             var nextAvailable = jQuery("#r2 input[type='radio']:not(:disabled)").first();
           //              if (nextAvailable.length) {
                          
           //                 var nextAvailableValue = nextAvailable.val();

           //                  const productUrl = `/products/${productHandle}.js`;
              
           //                  fetch(productUrl)
           //                    .then(response => {
           //                      if (!response.ok) throw new Error('Network response was not ok');
           //                      return response.json();
           //                    })
           //                    .then(data => {
           //                      const matchingVariant = data.variants.find(variant => 
           //                        variant.option1 === firstOptionValue && 
           //                        variant.option2 === nextAvailableValue
           //                      );
           //                      if (matchingVariant) {
           //                        console.log("Matching Variant ID:", matchingVariant.id);
           //                         const newUrl = `${baseURI.split('?')[0]}?variant=${matchingVariant.id}`;
      
           //                          // window.location.href = newUrl;
           //                        window.history.pushState(null, '', newUrl);
           //                        nextAvailable.prop("checked", true).click();
           //                         jQuery(".product-variant-id").val(matchingVariant.id);
           //                        const submitButton = jQuery(".product-form__submit");
           //                        submitButton.removeAttr("disabled");
                            
           //                        submitButton.find("span").text("Add to cart");
                                  
           //                      } else {
           //                        console.log("No matching variant found.");
           //                      }
           //                    })
           //                    .catch(error => {
           //                      console.error("There was an error fetching the product data:", error);
           //                    });
                           
           //              }
           //          } else {
           //              radioInput.prop("disabled", false);
           //              radioLabel.removeClass("out-ct-st"); 
           //          }
           //      });
           //  }, 500);


          
        var checkInput = jQuery(this).html();
        var unAvailableStr1 = "Unavailable";
        if(checkInput.indexOf(unAvailableStr1) == -1){
           var radioBut = jQuery("#r"+ jQuery(this).attr("data-id")+" input");
              for(var i = 0; i < radioBut.length; i++){
                radioBut[i].checked = false;
              }
            jQuery(this).prop('checked', true);
        	jQuery(".d"+ jQuery(this).attr("data-id")+" select").focus();
            jQuery(".d"+ jQuery(this).attr("data-id")+" select").val(jQuery(this).val());
  		    jQuery(".d"+ jQuery(this).attr("data-id")+" select").trigger("change");
        }
        	
     
        })
        .appendTo("#r"+globalctr).parent();
      
		}); 
  
      jQuery("#r"+globalctr+" input").each(function(i, e) {
        var checkLabel = jQuery(this).next('span').text();
        var unAvailableStr = "Unavailable";
        if(checkLabel.indexOf(unAvailableStr) != -1){
          jQuery(this).next('span').addBack().wrapAll('<label style="display:inline-block!important;" class="out-ct-st"></label>');
          jQuery(this).prop('disabled', true);  
        } else {
          jQuery(this).next('span').addBack().wrapAll('<label style="display:inline-block!important;"></label>');
          jQuery(this).prop('disabled', false); 
        }        
     
        
        });
  
    globalctr++;
}
  else{
    jQuery(this).attr('id', "");
     jQuery(this).removeClass('simple-form-container');
  }
});
};
                          
var ur = window.location.href;
if(ur.includes('/product')){
  $(document).ready(function(){
var ur = window.location.href;
Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var ctaCopy = "ORDER NOW";
  var lnk = '#';
  var stickyCopy = jQuery('.product__title h1').eq(0).text();
      var stickyprice = jQuery('product-info .price').eq(0).parent().html();
  
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="sticky-st-container" id="sticky-st-containerID"> <div class="sticky-st-container__outer"> <div class="sticky-st-container__inner"> <div class="sticky-st-copy"><p>'+stickyCopy+'</p><div class="st-reviews"></div></div><div class="sticky-st-item_column__button"> <div class="sticky-st-price">'+stickyprice+'</div><a class="sticky-st-item__button">'+ctaCopy+'</a></div></div></div></div></div>';
var y = document.getElementsByTagName('body');
if (document.getElementsByClassName('sticky-st-container').length == 0) {
    y[0].appendChild(sticky);
  console.log('here');
}
$('.sticky-st-item__button').click(function(){window.scrollTo({
    top: document.querySelectorAll('.product__title h1')[0].offsetTop,
    behavior: 'smooth'
});
}); 
    var asdfg = 0; var timerasdfg = setInterval(function(){
      
  if($('span.h1.fera-productReviews-avgRating-val').length && $('.st-reviews .custom-review').length == 0) {
     setTimeout(function(){ 
	jQuery('.st-reviews').append(jQuery('.custom-review').eq(0).clone())
    jQuery('.st-reviews .custom-review').html(jQuery('.st-reviews .custom-review').html().replaceAll('&nbsp;', ''));
    
     jQuery('.reviewsss').click(function(){
  window.scrollTo({
    top: document.querySelectorAll('.fera-productReviews')[0].offsetTop,
    behavior: 'smooth'
});
}); 
       }, 2500);
clearInterval(timerasdfg);}if( asdfg > 200){clearInterval(timerasdfg);}asdfg++;}, 50);
    
  
var mc = window.matchMedia("(min-width: 767px)");
var elem = document.getElementById("sticky-st-containerID");

function stickyProductAvailable() {
  var mainBtn = document.querySelector('.product-form__submit')
             || document.querySelector('form[action="/cart/add"] [name="add"]')
             || document.querySelector('.product-form__buttons button[type="submit"]');
  if (!mainBtn) return true;
  return !(mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true');
}

function stickyPastForm() {
  var btns = $('.product-form__buttons').eq(0);
  if (!btns.length) return false;
  return $(window).scrollTop() > btns.offset().top;
}

function slideShow() {
    elem.style.bottom = "0px";
    jQuery('body').addClass('sticky-sticky');
}
function slideHide() {
  elem.style.bottom = "-200px";
   jQuery('body').removeClass('sticky-sticky');
}

function evaluateSticky() {
  if (stickyProductAvailable() && stickyPastForm()) {
    slideShow();
  } else {
    slideHide();
  }
}

jQuery(document).scroll(function() {
    evaluateSticky();
});

/* Re-check on variant change. Dawn swaps the buy-buttons markup when the variant changes, so watch the product info block for that and the disabled-state flip. */
(function () {
  var infoRoot = document.querySelector('product-info')
              || document.querySelector('[id^="ProductInfo"]')
              || document.body;
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      evaluateSticky();
    });
  }).observe(infoRoot, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['disabled', 'aria-disabled']
  });
})(); 
  }); 
}
  
var ur = window.location.href;
if(ur.includes('/product')){
  
 jQuery(document).ready(function(){
   
    
Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var badgeTexts = ["FREE SHIPPING OVER $75",
                  "30-DAY MONEY BACK GUARANTEE",
                  " SECURE CHECKOUT"];
    
var popup = ["simple-shipping",   "simple-guarantee", ""];
var imgSrcs = [`<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
  <mask id="mask0_4_44" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="35" height="35">
    <rect width="35" height="35" fill="#D9D9D9"></rect>
  </mask>
  <g mask="url(#mask0_4_44)">
    <path d="M16.0417 28.3281V18.3385L7.29167 13.2708V23.2604L16.0417 28.3281ZM18.9583 28.3281L27.7083 23.2604V13.2708L18.9583 18.3385V28.3281ZM16.0417 31.6823L5.83333 25.8125C5.37153 25.5451 5.01302 25.1927 4.75781 24.7552C4.5026 24.3177 4.375 23.8316 4.375 23.2969V11.7031C4.375 11.1684 4.5026 10.6823 4.75781 10.2448C5.01302 9.8073 5.37153 9.45487 5.83333 9.18751L16.0417 3.31771C16.5035 3.05035 16.9896 2.91667 17.5 2.91667C18.0104 2.91667 18.4965 3.05035 18.9583 3.31771L29.1667 9.18751C29.6285 9.45487 29.987 9.8073 30.2422 10.2448C30.4974 10.6823 30.625 11.1684 30.625 11.7031V23.2969C30.625 23.8316 30.4974 24.3177 30.2422 24.7552C29.987 25.1927 29.6285 25.5451 29.1667 25.8125L18.9583 31.6823C18.4965 31.9497 18.0104 32.0833 17.5 32.0833C16.9896 32.0833 16.5035 31.9497 16.0417 31.6823ZM23.3333 12.4323L26.1406 10.8281L17.5 5.83334L14.6563 7.47396L23.3333 12.4323ZM17.5 15.8229L20.3438 14.1823L11.7031 9.18751L8.85938 10.8281L17.5 15.8229Z" fill="#0D0D0D"></path>
  </g>
</svg>`,
           `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
  <mask id="mask0_4_49" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="35" height="35">
    <rect width="35" height="35" fill="#D9D9D9"></rect>
  </mask>
  <g mask="url(#mask0_4_49)">
    <path d="M7.29167 32.0833C6.48958 32.0833 5.80295 31.7977 5.23177 31.2266C4.66059 30.6554 4.375 29.9688 4.375 29.1667V8.75C4.375 7.94792 4.66059 7.26129 5.23177 6.69011C5.80295 6.11893 6.48958 5.83334 7.29167 5.83334H8.75V2.91667H11.6667V5.83334H23.3333V2.91667H26.25V5.83334H27.7083C28.5104 5.83334 29.1971 6.11893 29.7682 6.69011C30.3394 7.26129 30.625 7.94792 30.625 8.75V17.5H27.7083V14.5833H7.29167V29.1667H17.5V32.0833H7.29167ZM27.7083 35C25.934 35 24.3845 34.4471 23.0599 33.3412C21.7352 32.2352 20.9028 30.8438 20.5625 29.1667H22.8229C23.1389 30.2361 23.7405 31.1111 24.6276 31.7917C25.5148 32.4722 26.5417 32.8125 27.7083 32.8125C29.1181 32.8125 30.3212 32.3142 31.3177 31.3177C32.3142 30.3212 32.8125 29.1181 32.8125 27.7083C32.8125 26.2986 32.3142 25.0955 31.3177 24.099C30.3212 23.1024 29.1181 22.6042 27.7083 22.6042C27.0035 22.6042 26.3472 22.7318 25.7396 22.987C25.1319 23.2422 24.5972 23.6007 24.1354 24.0625H26.25V26.25H20.4167V20.4167H22.6042V22.4948C23.2604 21.8629 24.026 21.3585 24.901 20.9818C25.776 20.605 26.7118 20.4167 27.7083 20.4167C29.7257 20.4167 31.4453 21.1276 32.8672 22.5495C34.2891 23.9714 35 25.691 35 27.7083C35 29.7257 34.2891 31.4453 32.8672 32.8672C31.4453 34.2891 29.7257 35 27.7083 35ZM7.29167 11.6667H27.7083V8.75H7.29167V11.6667Z" fill="#0D0D0D"></path>
  </g>
</svg>`,
               `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
  <mask id="mask0_7_126" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="35" height="35">
    <rect width="35" height="35" fill="#D9D9D9"></rect>
  </mask>
  <g mask="url(#mask0_7_126)">
    <path d="M8.74998 32.0833C7.9479 32.0833 7.26126 31.7977 6.69008 31.2266C6.1189 30.6554 5.83331 29.9687 5.83331 29.1667V14.5833C5.83331 13.7812 6.1189 13.0946 6.69008 12.5234C7.26126 11.9523 7.9479 11.6667 8.74998 11.6667H10.2083V8.75C10.2083 6.73263 10.9193 5.01302 12.3411 3.59114C13.763 2.16927 15.4826 1.45833 17.5 1.45833C19.5173 1.45833 21.237 2.16927 22.6588 3.59114C24.0807 5.01302 24.7916 6.73263 24.7916 8.75V11.6667H26.25C27.0521 11.6667 27.7387 11.9523 28.3099 12.5234C28.8811 13.0946 29.1666 13.7812 29.1666 14.5833V29.1667C29.1666 29.9687 28.8811 30.6554 28.3099 31.2266C27.7387 31.7977 27.0521 32.0833 26.25 32.0833H8.74998ZM8.74998 29.1667H26.25V14.5833H8.74998V29.1667ZM17.5 24.7917C18.3021 24.7917 18.9887 24.5061 19.5599 23.9349C20.1311 23.3637 20.4166 22.6771 20.4166 21.875C20.4166 21.0729 20.1311 20.3863 19.5599 19.8151C18.9887 19.2439 18.3021 18.9583 17.5 18.9583C16.6979 18.9583 16.0113 19.2439 15.4401 19.8151C14.8689 20.3863 14.5833 21.0729 14.5833 21.875C14.5833 22.6771 14.8689 23.3637 15.4401 23.9349C16.0113 24.5061 16.6979 24.7917 17.5 24.7917ZM13.125 11.6667H21.875V8.75C21.875 7.53472 21.4496 6.50173 20.5989 5.65104C19.7482 4.80034 18.7153 4.37499 17.5 4.37499C16.2847 4.37499 15.2517 4.80034 14.401 5.65104C13.5503 6.50173 13.125 7.53472 13.125 8.75V11.6667Z" fill="#1C1B1F"></path>
  </g>
</svg>`
              ]
var container = document.createElement('div');
container.className = 'simple-badges-outer-container';
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'simple-img-container';
var y = document.querySelectorAll('.usp_block')[0];
if(document.getElementsByClassName('simple-img-container').length == 0){
 
  container.appendAfter(y);  
  container.appendChild(imgContainer);
  var prodName = jQuery('h1.product_name').html();
  
  
}
    var ic = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <mask id="mask0_7_115" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
    <rect width="14" height="14" fill="#D9D9D9"></rect>
  </mask>
  <g mask="url(#mask0_7_115)">
    <path d="M6.41669 9.91667H7.58335V6.41667H6.41669V9.91667ZM7.00002 5.25001C7.1653 5.25001 7.30384 5.1941 7.41565 5.0823C7.52745 4.97049 7.58335 4.83195 7.58335 4.66667C7.58335 4.50139 7.52745 4.36285 7.41565 4.25105C7.30384 4.13924 7.1653 4.08334 7.00002 4.08334C6.83474 4.08334 6.6962 4.13924 6.5844 4.25105C6.47259 4.36285 6.41669 4.50139 6.41669 4.66667C6.41669 4.83195 6.47259 4.97049 6.5844 5.0823C6.6962 5.1941 6.83474 5.25001 7.00002 5.25001ZM7.00002 12.8333C6.19308 12.8333 5.43474 12.6802 4.72502 12.374C4.0153 12.0677 3.39794 11.6521 2.87294 11.1271C2.34794 10.6021 1.93231 9.98473 1.62606 9.27501C1.31981 8.56528 1.16669 7.80695 1.16669 7.00001C1.16669 6.19306 1.31981 5.43473 1.62606 4.72501C1.93231 4.01528 2.34794 3.39792 2.87294 2.87292C3.39794 2.34792 4.0153 1.9323 4.72502 1.62605C5.43474 1.3198 6.19308 1.16667 7.00002 1.16667C7.80697 1.16667 8.5653 1.3198 9.27502 1.62605C9.98474 1.9323 10.6021 2.34792 11.1271 2.87292C11.6521 3.39792 12.0677 4.01528 12.374 4.72501C12.6802 5.43473 12.8334 6.19306 12.8334 7.00001C12.8334 7.80695 12.6802 8.56528 12.374 9.27501C12.0677 9.98473 11.6521 10.6021 11.1271 11.1271C10.6021 11.6521 9.98474 12.0677 9.27502 12.374C8.5653 12.6802 7.80697 12.8333 7.00002 12.8333Z" fill="#009A67"></path>
  </g>
</svg>`
    
for(var i = 0; i < imgSrcs.length; i++){
                    
    var img = document.createElement('div');
    img.innerHTML = '<div class="simple-badge-container">'+imgSrcs[i]+'<span class="badge'+i+'" id="'+popup[i]+'">'+badgeTexts[i]+ic+' </span></div>';
    imgContainer.appendChild(img);
    img.className = "simple-badges-container";
           
    
}  
});
  
  
jQuery(document).ready(function(){
 var atc = 0; var timeratc = setInterval(function(){
  if(jQuery('.simple-badges').length == 0) {
  
      
    // div ng popup  
    // take note class at id
  jQuery('body').append(jQuery(`<div class="simple-popup simple-shipping-popup">
  <div class="popup-content">
    <div class="popup-title">Shipping Policy <span class="simple-close">×</span></div>
    <div class="popup-p">
      <div class="popup-contentt">
        <div class="rte">
          <meta charset="utf-8">
      <p><strong>How long does it take to process an order?</strong></p>
      <p>Each order has a different processing time. When an order is not a pre-order it will be shipped out as soon as possible however we do get back logged on orders quite often due to high demand. On average for a US order you can expect to wait a week for your order to be handed over to DHL/USPS however we will create your label as soon as we possibly can. For international order processing time can cary from 3 days to 2 weeks.</p>
      <p><strong>How long does shipping take for a United States order?</strong></p>
      <p>Once the order is handed over to DHL/USPS you can expect your order to be delivered in 2-4 days.</p>
      <p><strong>How long does shipping take for an international order?</strong></p>
      <p>Once shipped your order can take between 5 to 14 days depending on your location.</p>
      <p><strong>Where do we ship from?</strong></p>
      <p>All US orders are shipped from Wisconsin.</p>
      <p><strong>How much is shipping?</strong></p>
      <p>Shipping varies from product to product and will be calculated at checkout.</p>
      <p><strong>Do you order tracking?</strong></p>
      <p>Yes. All orders come with a tracking number. As soon as a label is created you will get a tracking number sent to your registered email. Sometimes this can go into your junk email. If that's the case please move to from junk to your inbox so future updates go straight to your inbox.</p>
      <p><strong>What's the returns policy?</strong></p>
      <p>The returns policy can be found on our refund policy page.</p>
      <p><strong>If there's a problem with my order, what can I do?</strong></p>
      <p>If there's a problem with your order please reach out to our customer service team, support@katamu.co</p>
        </div>
      </div>
    </div>
  </div>
</div>
`))
    jQuery('body').append(jQuery(`<div class="simple-popup simple-guarantee-popup">
  <div class="popup-content">
    <div class="popup-title">
      Returns and Exchange <span class="simple-close">×</span>
    </div>
    <div class="popup-p">
      <div class="popup-contentt">
        <div class="rte">
          <meta charset="utf-8"><meta charset="utf-8">
      <p>We have a 30-day return policy, which means you have 30 days after receiving your item to request a return.<br><br>To be eligible for a return, your item must be in the same condition that you received it, unworn or unused, with tags, and in its original packaging. You’ll also need the receipt or proof of purchase.<br><br>To start a return, you can contact us at<span>&nbsp;support@</span>katamu.co. If your return is accepted, we’ll send you our warehouse address to ship the items back to us. Items sent back to us without first requesting a return will not be accepted.<br><br>You can always contact us for any return question at<span>&nbsp;hello@katamu.co</span></p>
      <br>
      <p><strong>Damages and issues</strong><br>Please inspect your order upon reception and contact us immediately if the item is defective, damaged or if you receive the wrong item, so that we can evaluate the issue and make it right.</p>
      <br>
      <p><strong>Exceptions / non-returnable items</strong><br>Certain types of items cannot be returned, like perishable goods (such as food, flowers, or plants), custom products (such as special orders or personalized items), and personal care goods (such as beauty products). We also do not accept returns for hazardous materials, flammable liquids, or gases. Please get in touch if you have questions or concerns about your specific item.<br><br>Unfortunately, we cannot accept returns on sale items or gift cards.</p>
      <br>
      <p><strong>Exchanges</strong><br>The fastest way to ensure you get what you want is to return the item you have, and once the return is accepted, make a separate purchase for the new item.</p>
      <br>
      <p><strong>Refunds</strong><br>We will notify you once we’ve received and inspected your return, and let you know if the refund was approved or not. If approved, you’ll be automatically refunded on your original payment method. Please remember it can take some time for your bank or credit card company to process and post the refund too.</p>
      <p>&nbsp;</p>
        </div>
      </div>
    </div>
  </div>
</div>
`))
    
  jQuery('#simple-shipping').click(function(e){
  e.stopPropagation();
  jQuery('.simple-shipping-popup').eq(0).addClass('open')
    jQuery('body').addClass('popup');
  });   
  
        jQuery('#simple-guarantee').click(function(e){
  e.stopPropagation();
  jQuery('.simple-guarantee-popup').eq(0).addClass('open')
  jQuery('body').addClass('popup');
  });   
 jQuery('span.simple-close').click(function(){
  jQuery(this).parent().parent().parent().removeClass('open')
    jQuery('body').removeClass('popup');
}); 
    
    jQuery('.simple-popup').click(function(event){
  event.stopPropagation();
});
   jQuery(window).click(function() {
     if(jQuery('body > .open').length){
       jQuery('span.simple-close').click();
     }
  
});
clearInterval(timeratc);}if( atc > 200){clearInterval(timeratc);}atc++;}, 50);
});    
  
}